/**
 * Configuration for a custom app served via Module Federation.
 * Received from the entity metadata API as part of detailsView.
 */
export interface CustomAppConfig {
  /** Human-readable display name for the app */
  name: string;
  /** MFE app identifier — must be lowercase alphanumeric with hyphens (e.g. 'shipment-details') */
  appName: string;
}

export const APP_NAME_PATTERN = /^[a-z0-9-]+$/;

/**
 * Type guard that validates an unknown value is a CustomAppConfig with a valid appName.
 * Checks that both `name` and `appName` are non-empty strings, and that `appName`
 * matches the allowed pattern (lowercase alphanumeric + hyphens).
 */
export function isMfeAppConfig(app: unknown): app is CustomAppConfig {
  if (app == null || typeof app !== 'object') {
    return false;
  }

  const record = app as Record<string, unknown>;

  const hasValidName =
    typeof record.name === 'string' && record.name.length > 0;
  const hasValidAppName =
    typeof record.appName === 'string' &&
    record.appName.length > 0 &&
    APP_NAME_PATTERN.test(record.appName);

  return hasValidName && hasValidAppName;
}
